var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c(
          "button",
          {
            staticClass: "btn wf-product-download-button-close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--k-close",
              attrs: { "aria-label": "Close view mode 'swatch'" }
            })
          ]
        )
      ],
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }